
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/corporates.reducers';

export const selectDataState = createFeatureSelector<State>('corporateData');

export const selectCorporateData = createSelector(selectDataState, (state) => state.corporateData);
export const selectCorporateLoading = createSelector(selectDataState, (state) => state.loading);
export const selectCorporateError = createSelector(selectDataState, (state) => state.error);
